console.log("...");

window.addEventListener('load', function () {
  $("#btn_checkout_draft").click(function(e){
    $("#btn_checkout_draft").addClass("btn--loading");
    jQuery.getJSON('/cart.js', function(cart) {
      NewOrderDraft(cart);
    });
  });
});


function NewOrderDraft(cart){
  var customer = JSON.parse($("#customer_data").val());  
  var datos_adicionales = JSON.parse($("#datos_adicionales").val());  
  var descuento_nivel = $("#descuento_nivel").val();
  var fue_referido_por = $("#fue_referido_por").val();

  if(cart.attributes == null){
    cart.attributes  =[];
  }

  cart.attributes["descuento_nivel"] = descuento_nivel;  

  cart.attributes["is_referred"] = undefined;  
  cart.attributes["referido_por_id"] = undefined;  


  if(fue_referido_por != null && fue_referido_por.length > 0){
    cart.attributes["fue_referido_por"] = fue_referido_por;    
    cart.attributes["isReferredMLM"] = "true";  
  }

  for(var i in  datos_adicionales){
    var field = datos_adicionales[i];

    if(field.name =="nombre_nivel"){
      cart.attributes["nombre_nivel"] = field.value;  
    }
  }


  var wr ={
    ShopId : Shopify.shop,
    Customer : customer,
    Cart :  cart,
    Additional: datos_adicionales
  };

  console.log( JSON.stringify(wr));

  $.ajax({
    url: server + "/api/Order/NewDraftOrder",
    type: "POST",
    data: JSON.stringify(wr),
    contentType: "application/json;charset=utf-8",
    success: function (data) {
      if(data != null && data.isDraftOrder && data.draftOrderUrl != null && data.draftOrderUrl != ""){
        window.location.href =data.draftOrderUrl;
      }else{
        $("#goToCheckout-btn").click();
      }
      console.log(data);
    },
    error: function (msg) {
      console.log(msg);
      alert("Error:"+ msg);
      $("#"+id+"Loading").hide();
      $("#"+id).show();
    }
  });
}